import styled from 'styled-components'
import { get } from '@utils'

export const H4 = styled.h4`
  ${get('styles.h4')};
`
